import type {
  AdminSearchesResponse,
  AdminTopUsersResponse,
  AdminUsageResponse,
} from "@/api/admin-api"

export type DashboardSummaryData = {
  computedAt?: string
  usage: AdminUsageResponse
  searches: AdminSearchesResponse
  topUsers: AdminTopUsersResponse
}

// Fast queries (< 1s) - 30s stale time
export const FAST_STALE_TIME = 30_000
// Medium queries (1-3s) - 60s stale time
export const MEDIUM_STALE_TIME = 60_000
// Slow queries (3-15s) - 90s stale time
export const SLOW_STALE_TIME = 90_000
// Garbage collection time
export const GC_TIME = 5 * 60 * 1000 // 5 minutes
